import React from 'react'

import Botao from '../../../Mantine/Botao/index.jsx'
import Group from '../../../Mantine/Group/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'

import * as S from './styles.js'

export default function AlertaParqueTodo({ onClick, close, opened }) {
  return (
    <div>
      <Modal
        titulo="Reposição"
        width="400px"
        type="alerta"
        opened={opened}
        disableElipse
      >
        <S.ModalAlert>
          <p className="modal-alert">
            Você será redirecionado para a tela de <b>Reposição</b>, deseja prosseguir?
          </p>
          <Group position="center">
            <Botao label="Cancelar" variant="outline" onClick={close} />
            <Botao label="Confirmar" onClick={onClick} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
